import * as React from 'react';
import {SortableContainer} from 'react-sortable-hoc';
import type {Property} from '@deviceinsight/ng-ui-api-client';
import DraggableInfoItem from './DraggableInfoItem';
import type {InfoWidgetItem} from '../types';
import {WidgetProps} from '@deviceinsight/ng-ui-scale-lib/api';

type IndexProps = {
	oldIndex: number;
	newIndex: number;
};
type Props = {
	context: WidgetProps['context'];
	items: Array<InfoWidgetItem>;
	showDatapointSelectionTable: (index: number) => void;
	removeItem: (index: number) => void;
	onItemChange: (index: number, item: InfoWidgetItem) => void;
	assetProperties: Array<Property>;
	helperClass: string;
	onSortEnd: (p: IndexProps) => void;
	lockAxis: string;
	lockToContainerEdges: boolean;
	useDragHandle: boolean;
};

class InfoItemConfigs extends React.Component<Props> {
	render() {
		const {items, showDatapointSelectionTable, removeItem, onItemChange, assetProperties, context} = this.props;
		return (
			<tbody>
				{items.map((item, i) => (
					<DraggableInfoItem
						key={`item-${i}`}
						item={item}
						itemIndex={i}
						context={context}
						onSelectDatapoint={showDatapointSelectionTable}
						onItemChange={onItemChange}
						onRemoveItem={removeItem}
						assetProperties={assetProperties}
					/>
				))}
			</tbody>
		);
	}
}

const SortableInfoItemConfigs = SortableContainer(InfoItemConfigs);
export default SortableInfoItemConfigs as unknown as React.ComponentType<Props>;
